import React, { useEffect, useState ,useRef } from 'react';
import { useThemeContext } from '../../fetchdata/ThemeContext';
import getDecryptData from '../../helpers/getDecryptData';
import toast from 'react-hot-toast';
import axiosInstance from '../../axiosInstance';
import { Link } from 'react-router-dom';

const LiveTimer = () => {

   const dragRef = useRef(null);
  const pos = useRef({ x: 0, y: 0, offsetX: 0, offsetY: 0 });

  const onMouseDown = (e) => {
    e.preventDefault();
    pos.current.offsetX = e.clientX;
    pos.current.offsetY = e.clientY;

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    e.preventDefault();

    const dx = e.clientX - pos.current.offsetX;
    const dy = e.clientY - pos.current.offsetY;

    const element = dragRef.current;
    element.style.top = element.offsetTop + dy + 'px';
    element.style.left = element.offsetLeft + dx + 'px';

    pos.current.offsetX = e.clientX;
    pos.current.offsetY = e.clientY;
  };

  const onMouseUp = () => {
    document.removeEventListener('mouseup', onMouseUp);
    document.removeEventListener('mousemove', onMouseMove);
  };

    const [Order, setOrder] = useState([]);
  

 const timerStop = async (time,OrderId) => {
  const mydata = {
time,
OrderId,
otp: Order.otp,
  }
  try{
    await toast.promise(
        axiosInstance.post(`/admin/order/timer`, mydata),
        {
          loading: "Job ending...", // Loading message
          success: "Job ending successfully!", // Success message
          error: "Failed to end job", // Error message
        }
      );
 
      } catch (error) {
    console.error('Error start job:', error);
        }finally{
           dataAuth();
   }
}



  const decryptdatajson = getDecryptData();
  const DriverId = decryptdatajson._id;
  const { getAuthTime,dataAuth } = useThemeContext();

  const [MyDate, setMyData] = useState([]);
  const [timeStamps, setTimeStamps] = useState({});

  useEffect(() => {
    if (getAuthTime && getAuthTime.length !== 0) {
      setMyData(getAuthTime);
    }
  }, [getAuthTime,dataAuth]);

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimes = {};
      MyDate.forEach(order => {
        if (order.startTime && !order.endTime) {
          const start = new Date(order.startTime);
          const now = new Date();
          const diff = Math.floor((now - start) / 1000);

          const hrs = String(Math.floor(diff / 3600)).padStart(2, '0');
          const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
          const secs = String(diff % 60).padStart(2, '0');

          updatedTimes[order._id] = `${hrs}:${mins}:${secs}`;
        }
      });
      setTimeStamps(updatedTimes);
    }, 1000);

    return () => clearInterval(interval);
  }, [MyDate]);

  return (
    <>
      {MyDate && MyDate.length !== 0 && (
        <div className='position-absolute end-0 '  style={{zIndex:999999}} ref={dragRef}
      onMouseDown={onMouseDown} >
          
          {MyDate.map((data, index) => (
            <div
              className="bg-dark rounded p-3 my-2 d-inline-block rounded-pill border"
              style={{ width: '320px' ,cursor:"grab"}}
              
              key={index}
            >

              <div className="d-flex align-items-center gap-2 justify-content-between">


               <div className="d-flex  text-white  align-items-center gap-2 justify-content-between">
                 <h2 className="display-6 fw-bold text-center m-0" style={{width:80}}>
                {timeStamps[data._id] || '00:00:00'}
              </h2>
              <Link className='medium border-0 rounded-circle p-0 bg-transparent' 
               to={`/order/${data._id}`}  
    //           data-bs-toggle="dropdown"
    // aria-expanded="false" 
      >
              <i class="ri-stop-circle-fill text-danger h4 m-0 p-0 bg-white rounded-circle"></i>
              </Link> 


                 
  <ul className="dropdown-menu p-0">
   <div className="p-2 rounded bg-light   input-sm">
 
    <label for="otp"> OTP <span className='text-danger'> (required)   </span></label>
                            <input
                              type='number'
                               id="otp"
                              className="form-control"
                              name="otp"
                              value={Order?.otp }
                               onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      otp:e.target.value,
    }))
  }
                            />

                            
    <button className="btn btn-primary dropdown-toggle btn-sm mt-3" onClick={()=>{timerStop("end",data._id)}} >
                              End Job
                            </button> 
                          </div>
  </ul>

                </div>
             
             
<div className="dropdown">
  <button
    className="btn bg-transparent py-0 px-2  dropdown-toggle"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
  <i className="ri-more-2-fill fs-5 text-white"/>
  </button>
  <div className="dropdown-menu p-2">
 <h4 className='fs-6 pb-2 border-bottom'> 🧾 Job Details </h4>
     <p className="fs-6 mb-1 bg-light p-1 border text-dark" > 🛠️ :  {data.items[0].title || 'NA'} </p>

 <p className="fs-6 mb-1" > 👤 :  {data.details[0].username || 'NA'} </p>
  <p className="fs-6 mb-1" > 📞 : <a href={`tel:${data.details[0].phone || ''}`} className='text-success'> {data.details[0].phone || 'NA'}  </a></p>
  <p className="fs-6 mb-1" > 📍 :  {data.details[0].address || 'NA'} </p>
 
 <Link to={`/order/${data._id}`} className="btn-primary btn-sm w-100 d-block text-center"> View Job</Link>

  </div>
</div>



            </div>


              </div>


          ))}
        </div>
      )}
    </>
  );
};

export default LiveTimer;
